"use client";

import bg from "@/asset/images/bg-6.png";
import bgTablet from "@/asset/images/tablet/bg-6.png";
import bgMobile from "@/asset/images/mobile/bg-6.png";
import { Button } from "./ui/button";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function ContactSection() {
  const [currentBg, setCurrentBg] = useState(bg.src);

  useEffect(() => {
    // Function to update background based on window width
    const updateBackground = () => {
      if (window.innerWidth < 640) {
        setCurrentBg(bgMobile.src);
      } else if (window.innerWidth < 1024) {
        setCurrentBg(bgTablet.src);
      } else {
        setCurrentBg(bg.src);
      }
    };

    // Set initial background
    updateBackground();

    // Add event listener for window resize
    window.addEventListener("resize", updateBackground);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", updateBackground);
  }, []);

  return (
    <section id='contact'>
      <div
        className={`w-full min-h-[350px] lg:min-h-[500px] flex items-center justify-center gap-4 sm:gap-5 flex-col px-4 py-12 text-center bg-cover bg-top bg-no-repeat`}
        style={{
          backgroundImage: `url(${currentBg})`,
        }}>
        <h2 className='text-textColor2 text-[24px] md:text-[40px] lg:text-[68px] leading-tight lg:leading-[88px] font-bold'>
          Get in Touch
        </h2>
        <p className='text-black text-lg sm:text-xl md:text-2xl font-medium max-w-2xl mx-auto text-wrap md:text-nowrap'>
          Let's discuss how we can help your
          <br className='block md:hidden' /> project grow.{" "}
          <br className='hidden md:block lg:hidden' /> Contact us today!
        </p>

        <div className='flex flex-col sm:flex-row gap-4 mt-6 sm:mt-8 md:mt-10'>
          <Link
            href='https://klarda.com/en/registration-portal'
            target='_blank'>
            <Button
              size='lg'
              style={{
                background:
                  "linear-gradient(to right, #443DFF 0%, #9747FF 100%)",
              }}
              className='text-white hover:opacity-90 rounded-[15px] h-[52px] px-6 sm:px-10 shadow-btn text-sm md:text-base'>
              Contact Us
            </Button>
          </Link>
          <Link href='/details'>
            <Button
              variant='outline'
              size='lg'
              className='hover:bg-white/90 rounded-[15px] h-[52px] px-6 sm:px-10 border-[#0900F1] border-2 shadow-btn text-sm md:text-base'>
              Learn More
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
